<template>
    <section class="user-profile-header-wrap pt-60px pb-60px line-shape position-relative">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="user-profile-header-content d-flex align-center position-relative">
                        <div class="user-profile-header-image transition-3s position-relative overflow-hidden d-flex align-center">
                            <img class="transition-3s" :src="require('@/assets/images/team-1.png')" alt="User">
                        </div>
                        <div class="user-profile-header-content-body">
                            <h1>Developer Tanbir</h1>
                            <p class="bio">Full-stack WordPress Developer.</p>
                            <ul class="user-profile-header-meta d-flex flex-wrap">
                                <li class="d-flex gap-1 align-center"><el-icon><Timer /></el-icon> Member for 3 years, 8 months</li>
                                <li class="d-flex gap-1 align-center"><el-icon><Timer /></el-icon> Last seen this week</li>
                                <li class="d-flex gap-1 align-center"><el-icon><Calendar /></el-icon> Visited 226 days, 1 consecutive</li>
                            </ul>
                        </div>
                        <button class="edit-profile btn theme-btn position-absolute">
                            <el-icon><EditPen /></el-icon> Edit Profile
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Timer, Calendar, EditPen } from '@element-plus/icons-vue'

export default {
    name: 'UserProfileHeader',
    components: {
        Timer,
        Calendar,
        EditPen
    }
}
</script>